import { Box, Stack, StackDivider, Text } from '@chakra-ui/react';
import { Button, Progress } from 'antd';
import React, { useState } from 'react';
import { DownloadOutlined } from '@ant-design/icons';

const JDReportCard = ({ API_URL, jd, author_email, run_id }) => {
  const [isLoading, setIsLoading] = useState(false);

  const getPresignedLink = async (filename) => {
    setIsLoading(true);
    try {
      const { data } = await API_URL.get('get-presigned-url', {
        params: { author_email, run_id, filename },
      });
      const { signed_url: presignedUrl } = data;
      downloadFile(presignedUrl);
    } catch (error) {
      console.error('Error fetching presigned URL:', error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const downloadFile = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = ''; // Optional: Provide a default filename here if needed
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box borderWidth="1px" borderRadius="lg" overflow="hidden" p="4">
      <Stack divider={<StackDivider />} spacing="4">
        <Box>
          <Text height={45} fontSize="md">
            {jd.PK}
          </Text>
          <Progress
            id="pool-ranking-jd-progress"
            type="dashboard"
            percent={jd.matching}
            steps={10}
            trailColor="rgba(0, 0, 0, 0.06)"
            strokeWidth={18}
            style={{ marginTop: '10px' }}
          />
          <br />
          <Button
            size="small"
            icon={<DownloadOutlined />}
            loading={isLoading}
            shape="round"
            onClick={() =>
              getPresignedLink(`Ranking/ranking_output_${jd.PK}.csv`)
            }
          >
            Download Report
          </Button>
        </Box>
      </Stack>
    </Box>
  );
};

export default JDReportCard;
